import React, { useEffect, useState } from "react";
import { AdminPageTemplate, ColumnToolTip, ModalCallSummary, } from "../../features";
import { useOngoingCalls } from "../hooks/useOngoingCalls";
import { generateClient } from 'aws-amplify/api';
import * as Subscriptions from '../../graphql/subscriptions';

import LoadingBar from "react-top-loading-bar";
import { AppRouteUi, CallCenterActivityTypeOptions, ExportTableType, PaginationSettings, topLoaderProgress, } from "../../configs";
import { useFunctionalityCallCenterStatus } from "../hooks/functionalityCallCenterStatus";
import { useAppSelector, VRIAppStateType } from "../../core";
import { ColumnSelectionsModel, TableColumnExtend } from "../../models";
import { CallCenterOngoingCallsColumns } from "../../configs/AppJson/CallCenterOngoingCallsColumns";
import moment from "moment";
import { ApiSchemaFilter } from "../../models/api/filter";
import { useTopLoader } from "../hooks/useTopLoader";
import { OngoingCall } from "../../models/amplify/API";
import { formatPhoneNumber } from "../../utils/phoneNumberFormatting";
import { OngoingCallsAccordionRow } from "../../components/CallCenter/OngoingCallsAccordionRow";
import { useLiveHHMMSSFrom } from "../hooks/useLiveHHMMSSFrom";
import DataTable from "react-data-table-component";
import { NoDataComponent } from "../../features/admin/noDataComponent";
import type { VriOngoingView } from "../../models/mappers/ongoingCall";

export function PageOngoingCalls() {
  const callCenterId = useAppSelector(
    (state: VRIAppStateType) => state.auth.menuSettings?.callCenterSettings.callCenterId
  );
  const [isShowCommonFilter, setIsShowCommonFilter] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  // const [pageIndex, setPageIndex] = useState(PaginationSettings.initialPageIndex);
  const [pageSize, setPageSize] = useState(1000);
  const [hasPagingData, setHasPagingData] = useState<boolean>(false);
  const [disablePaging, setDisablePaging] = useState<boolean>(true);
  const [columnSelection, setColumnSelection] = useState<ColumnSelectionsModel[]>(CallCenterOngoingCallsColumns);
  const [columnSelectionModalShow, setColumnSelectionModalShow] = React.useState(false);

  let initialFilterData: ApiSchemaFilter = {
    filterQueries: [],
    sortQuery: {},
  };
  const [filterData, setFilterData] = useState<ApiSchemaFilter>(initialFilterData);
  const [filterDataChange, setFilterDataChange] = useState<number>(0);
  const [fetchIsStale, setFetchIsStale] = useState(false);
  const [emptyMessage, setEmptyMessage] = useState("No ongoing calls.");
  const [emptyVriMessage, setEmptyVriMessage] = useState("No ongoing video calls.");

  // const { calls, loading, err, refresh, trigger, pageSize, setPageSize, page, nextPage, prevPage, isLastPage, setPage } = useOngoingCalls({});
    const { opiCalls, vriCalls, loading, err, refresh, trigger, page, nextPage, prevPage, isLastPage, setPage } = useOngoingCalls({});


  useEffect(() => {
    setEmptyMessage(err ? "Unable to retrieve data." : "No ongoing calls.");
    setEmptyVriMessage(err ? "Unable to retrieve data." : "No ongoing video calls.");
    console.error(err);
  }, [err]);

  const { progress, handleFinished } = useTopLoader(loading);

  useEffect(() => {
    console.log("calls", opiCalls);
  }, [opiCalls])

  const LiveDurationCell: React.FC<{ startMs?: number }> = ({ startMs }) => {
  const text = useLiveHHMMSSFrom(startMs); 
  return <ColumnToolTip data={text} />;
};

  const formatDurationMs = (ms?: number | null) => {
    if (!ms || ms <= 0) return "-";
    return moment.utc(ms).format("HH:mm:ss");
  };

  const ongoingCallsTableColumns: TableColumnExtend<OngoingCall>[] =
    [
      {
        name: <ColumnToolTip data="Call Id" />,
        sortable: false,
        sortField: "Actor.Name",
        selector: (row: OngoingCall) => {
          return (
            <ColumnToolTip data={row.callId ?? ""} />
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "CallId")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Call SId" />,
        sortable: false,
        sortField: "Actor.Name",
        selector: (row: OngoingCall) => {
          return (
            <ColumnToolTip data={row.callSid ?? ""} />
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "CallSid")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Call Status" />,
        width: "200px",
        sortable: false,
        selector: (row: OngoingCall) => {
          return (
            <div className={`colored-ongoingCalls status-${row.callStatus}`}>
              {row.callStatus}
            </div>
          )
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "CallStatus")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Client Number" />,
        sortable: false,
        selector: (row: OngoingCall) => {
          return <ColumnToolTip data={row.clientNumber ? formatPhoneNumber(row.clientNumber) : "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "ClientNumber")?.isEnabled ? false : true,
      },
            {
        name: <ColumnToolTip data="Pin" />,
        sortable: false,
        selector: (row: OngoingCall) => {
          return <ColumnToolTip data={row.pin ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "Pin")?.isEnabled ? false : true,
      },

      {
        name: <ColumnToolTip data="Language Name" />,
        sortable: false,
        sortField: "Language",
        selector: (row: OngoingCall) => {
          return <ColumnToolTip data={row.languageName ?? "-"} />;
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "LanguageName")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Start Time" />,
        sortable: true,
        sortField: "StartTime",
        selector: (row: OngoingCall) => {
          const date = row.callStartedAt ? row.callStartedAt : null;

          return (
            <ColumnToolTip
              data={date ? moment(Number(date)).format("HH:mm:ss") : "-"}
            />
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "CallStartedAt")?.isEnabled ? false : true,
      },
      {
        name: <ColumnToolTip data="Duration" />,
        sortable: true,
        sortField: "StartTime",
        selector: (row: OngoingCall) => {

          return (
            <LiveDurationCell startMs={row.callStartedAt ? Number(row.callStartedAt) : undefined} />
          );
        },
        omit: columnSelection?.find((eachColumn) => eachColumn.propertyName === "CallStartedAt")?.isEnabled ? false : true,
      },

    ];

  const vriTableColumns: TableColumnExtend<VriOngoingView>[] = [
    {
      name: <ColumnToolTip data="Room Sid" />,
      sortable: false,
      selector: (row: VriOngoingView) => <ColumnToolTip data={row.roomSid ?? ""} />,
    },
    {
      name: <ColumnToolTip data="Room Status" />,
      sortable: false,
      selector: (row: VriOngoingView) => <ColumnToolTip data={row.roomStatus ?? "-"} />,
    },
    {
      name: <ColumnToolTip data="Unique Name" />,
      sortable: false,
      selector: (row: VriOngoingView) => <ColumnToolTip data={row.uniqueName ?? "-"} />,
    },
    {
      name: <ColumnToolTip data="Call Id" />,
      sortable: false,
      selector: (row: VriOngoingView) => <ColumnToolTip data={row.callId ?? "-"} />,
    },
    {
      name: <ColumnToolTip data="Chat Sid" />,
      sortable: false,
      selector: (row: VriOngoingView) => <ColumnToolTip data={row.chatSid ?? "-"} />,
    },
    {
      name: <ColumnToolTip data="Room Created" />,
      sortable: false,
      selector: (row: VriOngoingView) => {
        const date = row.roomCreatedAt ? Number(row.roomCreatedAt) : null;
        return <ColumnToolTip data={date ? moment(date).format("HH:mm:ss") : "-"} />;
      },
    },
    {
      name: <ColumnToolTip data="Duration" />,
      sortable: false,
      selector: (row: VriOngoingView) => <ColumnToolTip data={formatDurationMs(row.durationMilliseconds)} />,
    },
    {
      name: <ColumnToolTip data="Participants" />,
      sortable: false,
      selector: (row: VriOngoingView) => (
        <ColumnToolTip data={row.participants ? String(row.participants.length) : "0"} />
      ),
    },
  ];

  const vriTableStyles = {
    headCells: {
      style: {
        fontWeight: "700",
        fontSize: "13px",
        color: "#6e7476",
        textTransform: "uppercase" as const,
      },
    },
  };

        const ENABLE_CANARY = true;
    
        useEffect(() => {
            if (!ENABLE_CANARY) return;
    
            const client = generateClient();
    
            const observable = client.graphql({
                query: Subscriptions.onOngoingCalls,
                // authMode: 'userPool' | 'apiKey' | 'iam' | 'oidc'  // if needed
            });
    
            // Type-safed canary subscriber
            const sub = (observable as any).subscribe({
                next: (ev: any) => console.log('[CANARY onOngoingCalls] event:', ev),
                error: (err: any) => console.error('[CANARY onOngoingCalls] error:', err),
                complete: () => console.warn('[CANARY onOngoingCalls] complete'),
            });
    
            return () => {
                try { sub.unsubscribe?.(); } catch { }
            };
        }, []);



  return (
    <>
      <LoadingBar
        progress={progress}
        onLoaderFinished={handleFinished}
      />

      <AdminPageTemplate
        pagingKey="PageOngoingCalls"
        loaderProgress={progress}
        showExportOptions={false}
        showFilter={false}
        hideSearchBar={true}
        pageBreadCrumbTile="Call Center"
        pageTitle="Ongoing Calls"
        tableHeaders={ongoingCallsTableColumns}
        tableData={opiCalls || []}
        // pageIndex={page}
        pageSize={pageSize}
        // hasNextPage={!isLastPage}
        loading={loading}
        // onChangePageIndex={setPage}
        // onChangePageSize={(size: number) => { setPageSize(size); setPage(1); }}
        hasPagingData={hasPagingData}
        setHasPagingData={setHasPagingData}
        disablePaging = {disablePaging}
        pageName="ongoingCallsPage"
        tableType={ExportTableType.CallCenterStatusLog}
        callCenterId={callCenterId}
        showAutoRefresh={true}
        isAccordionEnabled={true}
        rowDetailsComponent={OngoingCallsAccordionRow}
        noDataFoundText={emptyMessage}
      />
      <div className="row">
        <div className="col-12 mt-3 mb-3">
          <div className="component-card ">
            <div className="component-card-header d-flex align-items-center justify-content-between border-top border-right border-left  ">
              <div>
                <span>Ongoing Video Calls</span>
              </div>
            </div>
            <div className="component-card-body border-top border-bottom border-right border-left p-0">
              <DataTable
                columns={vriTableColumns}
                data={vriCalls || []}
                noDataComponent={<NoDataComponent title={emptyVriMessage} />}
                customStyles={vriTableStyles}
                highlightOnHover={true}
                pointerOnHover={true}
                sortServer={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
